/**
 * @flow
 * @relayHash 842e85517655194eaf07cf5049ad007c
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type LanguagesAdminQueryResponse = {|
  +master: ?{| |};
|};
*/


/*
query LanguagesAdminQuery {
  master {
    ...Languages_master
  }
}

fragment Languages_master on Master {
  allLanguages(first: 50) {
    edges {
      node {
        id
        name
        code
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LanguagesAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Master",
        "name": "master",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Languages_master",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "LanguagesAdminQuery",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "LanguagesAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Master",
        "name": "master",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 50,
                "type": "Int"
              }
            ],
            "concreteType": "LanguageConnection",
            "name": "allLanguages",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "LanguageEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Language",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "code",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "allLanguages{\"first\":50}"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query LanguagesAdminQuery {\n  master {\n    ...Languages_master\n  }\n}\n\nfragment Languages_master on Master {\n  allLanguages(first: 50) {\n    edges {\n      node {\n        id\n        name\n        code\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/master/__generated__/LanguagesAdminQuery.graphql.js